import * as Account from 'app/react/entities/accounts/helpers';
import { fetchAll, createOne, updateOne, deleteOne } from './actions';

export const fetchAllForCurrentContext = () => (dispatch, getState) => {
    const state = getState();
    const accountId = Account.getCurrentId(state);
    return dispatch(fetchAll(accountId));
};

export const createOneForCurrentContext = (values) => (dispatch, getState) => {
    const state = getState();
    const accountId = Account.getCurrentId(state);
    return dispatch(createOne(accountId, values));
};

export const updateOneForCurrentContext = (groupId, values) => (dispatch, getState) => {
    const state = getState();
    const accountId = Account.getCurrentId(state);
    return dispatch(updateOne(accountId, groupId, values));
};

export const deleteOneForCurrentContext = (groupId) => (dispatch, getState) => {
    const state = getState();
    const accountId = Account.getCurrentId(state);
    return dispatch(deleteOne(accountId, groupId));
};


